import { render, staticRenderFns } from "./auth-layout.vue?vue&type=template&id=ed37b54a&scoped=true&"
import script from "./auth-layout.vue?vue&type=script&lang=js&"
export * from "./auth-layout.vue?vue&type=script&lang=js&"
import style0 from "./auth-layout.vue?vue&type=style&index=0&id=ed37b54a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed37b54a",
  null
  
)

export default component.exports